import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Permission } from "@shared/models/permissions"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type { User } from "@shared/models/user"
import type Session from "cc-frontend/services/session"
import styles from "./planbook-main.module.css"

interface Args {
  owner: User
  planbook: Planbook
  rotationCalendar: RotationCalendar
  permissions: Array<Permission>
  isInPlannerRoute: boolean
}

export default class PlanbookMainComponent extends Component<Args> {
  readonly styles = styles

  @tracked canShowMenu = false
  @tracked canShowPlanbookMenu = false

  @service declare session: Session
  @service declare router

  menuConstraints = [
    {
      to: "window",
      attachment: "together",
      pin: "right",
    },
  ]

  @action
  toggleMenu() {
    this.canShowMenu = !this.canShowMenu
  }
  @action
  togglePlanbookMenu() {
    this.canShowPlanbookMenu = !this.canShowPlanbookMenu
  }

  @action signInOrUp(e) {
    e.preventDefault()

    this.router.transitionTo("user.sign", {
      queryParams: { afterSignInRedirectTo: this.router.currentURL },
    })
  }
}
